import api from "api";
import { SERVICES } from "utils/constants";

export default class CreateNewsletterService {
  async createNewsletter(
    title: string, categoryIconName: string, content?: string, mediaFiles?: File[], accessRestrict?: string, emailRestrict?: string[], categoryName?: any): Promise<any> {
    let mediaUrl: string | undefined;
    let mediaType: string = "NONE";
    let hostUrl = 'https://storagetqi.blob.core.windows.net/tqieasy/';

    if (mediaFiles && mediaFiles.length > 0) {
      const file = mediaFiles[0];
      mediaType = file.type.startsWith("video") ? "VIDEO" : "IMAGE_BANNER";
      mediaUrl = hostUrl + (await this.saveMedia(title, file));
    }

    const body = {
      title,
      categoryName,
      categoryIconName,
      content,
      mediaUrl: mediaUrl ?? "",
      mediaType,
      accessRestrict,
      emailRestrict,
    };

    const { data } = await api.post("https://api.tqi.com.br/newsFeed", body);
    return data;
  }

  private async saveMedia(title: string, file: File): Promise<string | undefined> {
    const formData = new FormData();
    formData.append("file", file);

    const isVideo = file.type.startsWith("video");
    const uploadUrl = isVideo
      ? SERVICES.NEWSFEED_VIDEO_UPLOAD + `/${title}.mp4`
      : SERVICES.NEWSFEED_IMAGE_UPLOAD + `/${title}.jpg`;

    const { data } = await api.post(uploadUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    return data;
  }
}
